import React, { useRef } from 'react';

import { motion as m, useInView } from 'framer-motion';

//**Shared components */
import Button from '@src/components/shared/Button';
import Image from '@src/components/shared/Image';
import Typography from '@src/components/shared/Typography';

//**import assets */
import framebg from '@assets/Images/bg/frame-bg.png';
import {
  left_right_variants,
  top_bottom_variants,
} from '@src/utils/animations';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  const navigate = useNavigate()


  return (
    <div className="md:p-[7.5rem] p-8">
      <div ref={ref} className="flex md:flex-row gap-10 flex-col">
        <div className="mt-6">
          <div className="overflow-hidden">
            <Typography
              mAnimate={{
                mVariants: top_bottom_variants,
                isInView: isInView,
                mDelay: 0,
              }}
              className=" text-base font-normal block"
            >
              Our Expereince
            </Typography>
          </div>
          <div className="overflow-hidden">
            <Typography
              mAnimate={{
                mVariants: top_bottom_variants,
                isInView: isInView,
                mDelay: 0.1,
              }}
              variant="P_SemiBold_H3"
              className="block  text-mid-black"
            >
              Lorem ipsum dolor sit
            </Typography>
          </div>
          <div className="overflow-hidden">
            <Typography
              mAnimate={{
                mVariants: top_bottom_variants,
                isInView: isInView,
                mDelay: 0.2,
              }}
              variant="P_SemiBold_H3"
              className=" text-primary-blue block"
            >
              amet consectetur.
            </Typography>
          </div>
          <div className="overflow-hidden">
            <Typography
              mAnimate={{
                mVariants: top_bottom_variants,
                isInView: isInView,
                mDelay: 0.3,
              }}
              variant="P_Regular_H6"
              className="mt-7 block"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nascetur
              imperdiet at a augue ullamcorper. Leo faucibus feugiat rutrum
              aenean. Nisi, lectus aliquet aliquam consectetur augue praesent.
              Lorem vulputate orci eget mi, sed pulvinar.
            </Typography>
          </div>
          <div className="overflow-hidden">
            <Typography
              mAnimate={{
                mVariants: top_bottom_variants,
                isInView: isInView,
                mDelay: 0.3,
              }}
              variant="P_Regular_H6"
              className="mt-3 block"
            >
              Ornare etiam erat volutpat tempor fringilla mi. Elit a blandit
              faucibus est, dui interdum ut amet. Adipiscing feugiat vel at
              posuere in. Pellentesque volutpat vestibulum.
            </Typography>
          </div>
          <div className=" overflow-hidden">
            <m.div
              initial="initial"
              animate={isInView && 'visible'}
              variants={top_bottom_variants}
              viewport={{ once: true }}
              custom={0.4}
            >
              <Button className="my-8" onClick={() => navigate('/contact-us')}>Contact Us</Button>
            </m.div>
          </div>
        </div>
        <div className=" overflow-hidden">
          <m.div
            initial="initial"
            whileInView="slidein"
            custom={0.6}
            variants={left_right_variants}
            viewport={{ once: true }}
          >
            <Image src={framebg} />
          </m.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
